import { GridColumns } from "components/Common.models";
import ListSelectionModal from "components/SelectionListModal/ListSelectionModal";
import SelectionModal from "components/SelectionModal/SelectionModal";
import * as AppUrls from "constants/AppUrls";
import { CREATE_SUCCESS_MSG } from "constants/NotificationMsgs";
import DispatchContext from "context/DispatchContext";
import AgGrid from "elements/AgGrid";
import Lookup from "elements/Lookup";
import {
  dateFormmaterNoTime,
  formatNumber,
  notificationMessage,
} from "global/helpers";
import backArrow from "img/back-arrow.svg";
import { getReasons } from "pages/EcommerceAdmin/Services/adminServices";
import { InvoiceStateArray } from "pages/Invoices/InvoiceEnums";
import { InvoiceEntry } from "pages/Invoices/Invoices.model";
import {
  getReceiveInvoiceById,
  getReceiveInvoices,
} from "pages/Invoices/InvoicesServices/InvoicesServices";
import PurchaseSelectionModal from "pages/Purchasing/PurchaseSelectionModal";
import {
  getPurchaseOrder,
  getPurchaseOrders,
} from "pages/Purchasing/PurchasingServices/PurchaseServices";
import { useContext, useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import { Controller, FormProvider, useForm } from "react-hook-form";
import { useMutation, useQuery } from "react-query";
import { useHistory } from "react-router-dom";
import * as colDefs from "../../constants/colDefs";
import ReasonsModal from "./ReasonsModal";
import { createVendorRma } from "./RmaServices/RmaServices";

const CreateVRma = () => {
  const history = useHistory();
  const [openSelectionOrder, setOpenSelectionOrder] = useState<boolean>(false);
  const [openSelectionInvoice, setOpenSelectionInvoice] =
    useState<boolean>(false);
  const [showSerialSelection, setShowSerialSelection] =
    useState<boolean>(false);
  const [showReasonModal, setShowReasonModal] = useState<boolean>(false);
  const [selectedInvoice, setSelectedInvoice] = useState<InvoiceEntry>();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [selectedDetails, setSelectedDetails] = useState(null);
  const [rowChecked, setRowChecked] = useState([]);
  const selectedItem = useRef(null);
  const gridItems = useRef([]);
  const reasonIndex = useRef(null);

  const appDispatch = useContext(DispatchContext);

  const { data: reasons, refetch } = useQuery("reasons", getReasons);

  const { data: invoices } = useQuery("receive-invoices", getReceiveInvoices);

  const { data: purchaseOrders, mutate } = useMutation(getPurchaseOrders);

  useEffect(() => {
    mutate({ vendorId: null, hubId: null, poStatus: 6, poType: 1 });
  }, [mutate]);

  const getInvoiceDetails = useMutation(getReceiveInvoiceById, {
    onSuccess(res) {
      gridItems.current = res.items;
      let details = {
        customerId: res.vendorId,
        customer: res.vendorNumber,
        company: res.company,
        hub: res.hubKey,
        count: res.items.length,
        total: res.total,
      };
      setSelectedDetails(details);
    },
  });

  const getOrderDetails = useMutation(getPurchaseOrder, {
    async onSuccess(res) {
      const { data } = res;
      gridItems.current = data.purchaseOrderItems.map((item) => ({
        ...item,
        price: item.cost,
        quantity: item.quantityOrdered,
      }));
      let details = {
        customerId: data.vendorId,
        customer: data.vendorNumber,
        company: data.company,
        hub: data.hubKey,
        count: data.purchaseOrderItems.length,
        total: data.total,
      };
      setSelectedDetails(details);
    },
  });

  const addRma = useMutation(createVendorRma, {
    async onSuccess() {
      let notification = {
        variant: "success",
        msg: `RMA ${CREATE_SUCCESS_MSG}`,
      };
      appDispatch({ type: "notification", value: notification });
      history.push(AppUrls.vendor_rma);
    },
    onError(error) {
      let notification = {
        variant: "danger",
        msg: notificationMessage(error, "Problem adding rma"),
      };
      appDispatch({ type: "notification", value: notification });
    },
  });

  const columns: GridColumns[] = [
    {
      field: "invoiceNumber",
      headerName: "Bill No.",
      minWidth: colDefs.smWidth,
    },
    {
      field: "immediate",
      headerName: "Is Immediate",
      minWidth: colDefs.smWidth,

      valueGetter: (params) => {
        return params.data.immediate ? "Yes" : "No";
      },
    },
    {
      field: "company",
      headerName: "Company",
      minWidth: colDefs.mWidth,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: colDefs.booleanWidth,

      valueGetter: (params) => {
        return InvoiceStateArray[params.data.status - 1];
      },
    },
    {
      field: "orderDate",
      headerName: "Order Date",
      minWidth: colDefs.smWidth,

      cellRenderer: (params) =>
        params.value ? dateFormmaterNoTime(params.value) : "",
    },
    {
      field: "paidAmount",
      headerName: "Remaining Amount",
      minWidth: colDefs.smWidth,

      valueGetter: (params) => {
        return `$${params.data?.balance?.toFixed(2) ?? "0.00"}`;
      },
    },
    {
      field: "paidDate",
      headerName: "Paid Date",
      minWidth: colDefs.dateWidth,

      cellRenderer: (params) =>
        params.value ? dateFormmaterNoTime(params.value) : "",
    },
    {
      field: "total",
      minWidth: colDefs.smWidth,

      headerName: "Total",
      valueGetter: (params) => {
        return `$${params.data?.total?.toFixed(2) ?? "0.00"}`;
      },
    },
    {
      field: "hubKey",
      minWidth: colDefs.smWidth,
      headerName: "Hub ID",
    },
    {
      field: "vendorNumber",
      headerName: "Vendor",
      minWidth: colDefs.smWidth,
    },
  ];

  const gridColumns = [
    {
      headerName: "",
      field: "RowSelect",
      checkboxSelection: true,
      filter: false,
      width: 50,
    },
    {
      field: "itemNumber",
      headerName: "Item Number",
      width: 200,
    },
    {
      field: "description",
      headerName: "Item Description",
      width: 200,
    },
    {
      field: "return",
      headerName: "Return QTY",
      editable: true,
      width: 150,
    },
    {
      field: "returnReason",
      headerName: "Return Reason",
      editable: true,
      width: 250,

      cellEditorSelector: () => {
        let customReasons = reasons?.map((d) => {
          return d.reason;
        });
        customReasons.unshift("Add New");
        return {
          component: "agRichSelectCellEditor",
          params: { values: customReasons },
        };
      },
    },
    {
      field: "quantity",
      headerName: "QTY",
      width: 100,
    },
    {
      field: "price",
      headerName: "Cost",
      cellRenderer: (params) => formatNumber(params.value),
      width: 100,
    },
    {
      field: "subTotal",
      headerName: "Subtotal",
      cellRenderer: (params) =>
        formatNumber(params.data.quantity * params.data.price),
      width: 120,
    },
    {
      field: "returnTotal",
      headerName: "Return Total",
      valueGetter: (params) =>
        formatNumber(params.data.return * params.data.price),
      width: 200,
    },
    {
      field: "",
      headerName: "",
      cellRendererFramework: (params) => {
        return params?.data && params?.data?.serials.length > 0 ? (
          <button
            type="button"
            className="btn btn-link text-decoration-none ms-0 ps-0"
            onClick={() => addSerial(params.data)}
          >
            Add Serial
          </button>
        ) : (
          "-"
        );
      },
    },
  ];

  const methods = useForm({
    mode: "onChange",
    reValidateMode: "onChange",
  });

  const {
    formState: { errors, isDirty, isSubmitSuccessful },
    handleSubmit,
    reset,
    control,
    setValue,
  } = methods;

  const onBackClick = () => {
    history.push(AppUrls.vendor_rma);
  };

  const onInvoiceSelected = (invoice) => {
    setValue("billId", invoice.receiveInvoiceId, { shouldDirty: true });
    setValue("purchaseOrderId", null);
    setSelectedInvoice(invoice);
    setSelectedOrder(null);
    setOpenSelectionInvoice(false);
    getInvoiceDetails.mutate({ queryKey: [invoice.receiveInvoiceId] });
  };

  const onOrderSelected = (order) => {
    setValue("purchaseOrderId", order.purchaseOrderId, { shouldDirty: true });
    setValue("billId", null);
    setSelectedOrder(order);
    setSelectedInvoice(null);
    setOpenSelectionOrder(false);
    getOrderDetails.mutate({ queryKey: [order.purchaseOrderId] });
  };

  const addSerial = (values) => {
    selectedItem.current = values.invoiceItemId || values.purchaseOrderItemId;
    setShowSerialSelection(true);
  };

  const selectSerial = (items) => {
    gridItems.current = gridItems.current.map((item) => {
      if (
        item.invoiceItemId === selectedItem.current ||
        item.purchaseOrderItemId === selectedItem.current
      )
        return { ...item, selectedSerials: items.map((i) => i.id) };
      return { ...item };
    });
    setShowSerialSelection(false);
  };

  const onReasonAdded = (reason) => {
    refetch();
    gridItems.current = gridItems.current.map((item) => {
      if (item.invoiceItemId === reasonIndex.current)
        return { ...item, returnReason: reason };
      return { ...item };
    });
    setShowReasonModal(false);
  };

  const onCancelReason = () => {
    gridItems.current = gridItems.current.map((item) => {
      if (item.invoiceItemId === reasonIndex.current)
        return { ...item, returnReason: null };
      return { ...item };
    });
    setShowReasonModal(false);
  };

  const onCancel = () => {
    reset();
    setSelectedOrder(null);
    setSelectedInvoice(null);
    setSelectedDetails(null);
  };

  const onSubmit = (values) => {
    let checkedItems = rowChecked.filter((n) =>
      rowChecked.some((n2) =>
        n.purchaseOrderItemId
          ? n.purchaseOrderItemId === n2.purchaseOrderItemId
          : n.invoiceItemId === n2.invoiceItemId
      )
    );
    if (checkedItems.length === 0) {
      let notification = {
        variant: "danger",
        msg: "Please select items to return from the table",
      };
      appDispatch({ type: "notification", value: notification });
    } else if (checkedItems.some((item) => !item.return)) {
      let notification = {
        variant: "danger",
        msg: "Please choose item quantity to return",
      };
      appDispatch({ type: "notification", value: notification });
    } else if (
      checkedItems.some(
        (item) => isNaN(item.return) || Number(item.return) > item.quantity
      )
    ) {
      let notification = {
        variant: "danger",
        msg: "Invalid quantity to return entered",
      };
      appDispatch({ type: "notification", value: notification });
    } else if (
      checkedItems.some(
        (item) =>
          item?.selectedSerials?.length > 0 &&
          Number(item?.return) !== item?.selectedSerials?.length
      )
    ) {
      let notification = {
        variant: "danger",
        msg: "Please add serials to selected items",
      };
      appDispatch({ type: "notification", value: notification });
    } else {
      let data = {
        ...values,
        vendorId: selectedDetails.customerId,
        items: checkedItems.map((item) => ({
          itemHubId: item.itemHubId,
          cost: item.price,
          quantity: item.return,
          serials: item.selectedSerials ?? [],
          reason: reasons?.find((a) => a.reason === item.returnReason)?.id,
        })),
      };
      addRma.mutate(data);
    }
  };

  let itemSerials = gridItems.current.find(
    (item) =>
      item.invoiceItemId === selectedItem.current ||
      item.purchaseOrderItemId === selectedItem.current
  );

  return (
    <>
      <style>
        {`.ag-theme-material.ag-popup .ag-virtual-list-container .ag-virtual-list-item[aria-posinset="1"] .ag-rich-select-row {
                        background-color: #347AE6;
                        margin-right:  25%;
                        border-radius: 4px;
                        color: white;
                        cursor: pointer
                    }
                    .ag-theme-material.ag-popup .ag-virtual-list-container  {
                      align-text:center;
                      margin-left:25%;

                  }`}
      </style>

      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="page-title page-title-editable">
            <div className="back-btn " onClick={onBackClick}>
              <img src={backArrow} alt="back arrow" />
              Creating RMA
            </div>
            <div className="d-flex justify-content-between ">
              <button
                type="button"
                className="btn btn-outline-primary no-border"
                disabled={!isDirty}
                onClick={onCancel}
              >
                Reset
              </button>
              <button
                type="submit"
                className="btn btn-success"
                disabled={!isDirty || isSubmitSuccessful}
              >
                Create
              </button>
            </div>
          </div>
          <div className="page-content-wrapper">
            <div className="page-content">
              <div className="row">
                <div className="col-sm-3">
                  <label>
                    Bill No. <span className="text-danger">*</span>
                  </label>
                  <Lookup
                    onButtonClicked={() => setOpenSelectionInvoice(true)}
                    inputName="billId"
                    initialData={invoices?.data?.map((item) => ({
                      ...item,
                      id: item.receiveInvoiceId,
                      name: item.invoiceNumber,
                    }))}
                    onSelection={onInvoiceSelected}
                    inputValue={selectedInvoice?.invoiceNumber}
                    isDisabled={selectedOrder ? true : false}
                  />
                </div>
                <div className="col-sm-3">
                  <label>
                    Purchase Order No. <span className="text-danger">*</span>
                  </label>
                  <Lookup
                    onButtonClicked={() => setOpenSelectionOrder(true)}
                    inputName="purchaseOrderId"
                    initialData={purchaseOrders?.data?.map((item) => ({
                      ...item,
                      id: item.purchaseOrderId,
                      name: item.purchaseOrderNumber,
                    }))}
                    onSelection={onOrderSelected}
                    inputValue={selectedOrder?.purchaseOrderNumber}
                    isDisabled={selectedInvoice ? true : false}
                  />
                </div>
                <div className="col-sm-3 offset-sm-1">
                  <div className="form-group">
                    <label>
                      RMA Date <span className="text-danger">*</span>
                    </label>
                    <Controller
                      control={control}
                      name="vendorRMADate"
                      rules={{ required: true }}
                      render={({ field: { onChange, value } }) => (
                        <DatePicker
                          showYearDropdown
                          dateFormatCalendar="MMMM"
                          yearDropdownItemNumber={15}
                          scrollableYearDropdown
                          onChange={(e) => {
                            onChange(e);
                          }}
                          selected={value ? value : null}
                        />
                      )}
                    />
                    {errors.vendorRMADate && (
                      <p className="text-danger">This field is required</p>
                    )}
                  </div>
                </div>
              </div>
              <div className="row mt-5">
                <div className="col-lg-2 col-sm-12">
                  <label>Vendor No.</label>
                  <div>
                    {selectedDetails?.customer ?? (
                      <span className="text-muted fst-italic">Vendor No.</span>
                    )}
                  </div>
                </div>
                <div className="col-lg-2 col-sm-12">
                  <label>Company Name</label>
                  <div>
                    {selectedDetails?.company ?? (
                      <span className="text-muted fst-italic">
                        Company Name
                      </span>
                    )}
                  </div>
                </div>
                <div className="col-lg-2 col-sm-12">
                  <label>Hub Id</label>
                  <div>
                    {selectedDetails?.hub ?? (
                      <span className="text-muted fst-italic">Hub Id</span>
                    )}
                  </div>
                </div>
                <div className="col-lg-2 col-sm-12">
                  <label>Item Count</label>
                  <div>
                    {selectedDetails?.count ?? (
                      <span className="text-muted fst-italic">Item Count</span>
                    )}
                  </div>
                </div>
                <div className="col-lg-2 col-sm-12">
                  <label>Total</label>
                  <div>
                    {selectedDetails?.total ? (
                      formatNumber(selectedDetails?.total)
                    ) : (
                      <span className="text-muted fst-italic">Total</span>
                    )}
                  </div>
                </div>
              </div>
              <div className="h-450 mt-5">
                <AgGrid
                  columns={gridColumns}
                  data={gridItems.current}
                  multipleSelection={true}
                  setRowChecked={setRowChecked}
                />
              </div>
            </div>
          </div>
        </form>
      </FormProvider>
      <SelectionModal
        modal="Invoice"
        showModal={openSelectionInvoice}
        setShowModal={setOpenSelectionInvoice}
        data={invoices?.data}
        columns={columns}
        setRowClicked={onInvoiceSelected}
      />
      <PurchaseSelectionModal
        showModal={openSelectionOrder}
        onExit={setOpenSelectionOrder}
        onSelectedItem={onOrderSelected}
      />
      <ListSelectionModal
        showModal={showSerialSelection}
        title="Serials"
        data={
          selectedItem.current
            ? itemSerials?.serials.map((serial) => {
                return { title: serial.serialNo, id: serial.serialId };
              })
            : []
        }
        selectedValues={
          selectedItem.current ? itemSerials?.selectedSerials : []
        }
        onSelectData={selectSerial}
        onExit={() => setShowSerialSelection(false)}
        selectValue={itemSerials?.selectedSerials?.length}
        isInvoice={true}
        maxValue={itemSerials?.serials?.length ?? 0}
      />
      <ReasonsModal
        onConfirm={onReasonAdded}
        onClose={onCancelReason}
        showModal={showReasonModal}
      />
    </>
  );
};

export default CreateVRma;
